import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PRODUCT_FEATURES, ProductFeature } from '../products.data';

@Component({
  selector: 'app-products-nav',
  templateUrl: './products-nav.component.html',
  styleUrls: ['./products-nav.component.scss'],
})
export class ProductsNavComponent {
  /** Active module id (section on overview or detail page). */
  @Input() activeId = '';
  /** overview = anchor scroll on /products; detail = links to /products/:id */
  @Input() mode: 'overview' | 'detail' = 'overview';

  @Output() sectionSelect = new EventEmitter<string>();

  readonly features: ProductFeature[] = PRODUCT_FEATURES;

  onOverviewSectionClick(featureId: string, event: Event): void {
    event.preventDefault();
    this.sectionSelect.emit(featureId);
  }

  trackByFeatureId(_index: number, feature: ProductFeature): string {
    return feature.id;
  }
}
